                                                                               dealershipModule.factory('dealerPreferencesService', ['$http','AppSettings','DealerPreferences', 'commonRESTCallService', 'erateSessionVarsService','imSessionVarsService', 'settingsCacheService', 'dealershipModuleConstants', '$q', '$rootScope', 'dealershipEvents',
function ($http, appSettings, DealerPreferences, commonRESTCallService, erateSessionVarsService,imSessionVarsService, settingsCacheService, dealershipModuleConstants, $q, $rootScope, dealershipEvents ) {
    var dealerPreferencesService = {};

    //todo - eventually make this an API somewhere
    var _providersUsingProductType = ["EASYCARE"];

    dealerPreferencesService.providerUsesProductType = function(){
        return _providersUsingProductType.indexOf(imSessionVarsService.getCurrentProviderCode()) >= 0;
    }

    //retrieve display preferences by product code (internalproductid)
    dealerPreferencesService.getProductDisplayPreferences = function(productCode, productTypeCode, dateOfSale){
        var deferred = $q.defer();

        if (!(dateOfSale instanceof Date)){
            dateOfSale = new Date(dateOfSale);
        }

        //OK we are now caching all preferences when page initially loads
        // so we should only have cached or use the "DEFAULT" display preference

        var cachedPreferences = settingsCacheService.getCachedPreferences(productCode, dateOfSale);
        if (cachedPreferences) {
            deferred.resolve(cachedPreferences);
        }
        if (!cachedPreferences && productTypeCode){
            cachedPreferences = settingsCacheService.getCachedPreferences(productTypeCode, dateOfSale);
            if (cachedPreferences){
                deferred.resolve(cachedPreferences);
            }
        }
        if (!cachedPreferences) {
            cachedPreferences = settingsCacheService.getCachedPreferences(dealershipModuleConstants.DEFAULT_PRODUCT, dateOfSale);

            deferred.resolve(cachedPreferences);
         }
        return deferred.promise;
    };

    // retrieve display preferences for all products;
    dealerPreferencesService.getAllProductDisplayPreferences = function(dateOfSale){
        var deferred = $q.defer();

        if (!(dateOfSale instanceof Date)){
            dateOfSale = new Date(dateOfSale);
        }
        var formattedDate = dateOfSale.yyyymmdd();

        settingsCacheService.clearCachedPreferences();

        var url = appSettings.startSPANDealerPreferencesURL + "/DisplayPreferences/" + imSessionVarsService.getCurrentProviderCode() + "/" + erateSessionVarsService.getCurrentDealerAccountCode() +
            "/" + formattedDate;

        commonRESTCallService.getFromServer(url)
            .success(function (data, status) {
                var preferences = [];
                data = prependDefault(data); // in case server doesn't provide a default
                data.forEach(function(bsPref) {
                    var pref = DealerPreferences.createFromBusinessServices(bsPref);
                    preferences.push(pref);
                    settingsCacheService.setCachedPreferences(pref.productCode, dateOfSale, pref);
                });

                $rootScope.$broadcast(dealershipEvents.dealerDisplayPreferencesComplete);
                deferred.resolve(preferences.slice(1));  // drop the default, now that we have it in the cache
            })
            .error(function (data, status) {
                deferred.reject(status + ' ' + JSON.stringify(data));
            });

        return deferred.promise;
    };

    function prependDefault(data) {
        // Server should provide default as first item in data.  But if it is missing,
        // we will insert a default here.
        if (data.length == 0  || data[0].ProductCode != dealershipModuleConstants.DEFAULT_PRODUCT) {
            var bsPrefs = DealerPreferences.createBusinessServicesDefault();
            return [bsPrefs].concat(data);
        }
        return data;
    }

    function checkForUnfriendlyProductCode(productCode) {
        if (productCode.indexOf(':') >= 0) { return productCode.replace(':','-fcolon-');}
        return productCode;
    }
    //retrieve product default deductibles
    dealerPreferencesService.getProviderDefaultDeductibles = function(productCode, dateOfSale){
        var deferred = $q.defer();

        if (!(dateOfSale instanceof Date)){
            dateOfSale = new Date(dateOfSale);
        }
        var formattedDate = dateOfSale.yyyymmdd();

        var url =  appSettings.startSPANDealerPreferencesURL + "/DefaultDeductibles/" + imSessionVarsService.getCurrentProviderCode()
            + "/" + erateSessionVarsService.getCurrentDealerAccountCode() +
            "/" + checkForUnfriendlyProductCode(productCode) + "/" + formattedDate;
        commonRESTCallService.getFromServer(url)
            .success(function (data, status) {
                deferred.resolve(data);
            })
            .error(function (data, status) {
                deferred.reject(status + ' ' + JSON.stringify(data));
            });
        return deferred.promise;
    };

    //retrieve product default coverages
    dealerPreferencesService.getProviderDefaultCoverages = function(productCode, dateOfSale){
        var deferred = $q.defer();

        if (!(dateOfSale instanceof Date)){
            dateOfSale = new Date(dateOfSale);
        }
        var formattedDate = dateOfSale.yyyymmdd();
        //
        var url =  appSettings.startSPANDealerPreferencesURL + "/DefaultCoverages/" + imSessionVarsService.getCurrentProviderCode() + "/" + erateSessionVarsService.getCurrentDealerAccountCode() +
            "/" + checkForUnfriendlyProductCode(productCode) + "/" + formattedDate;
        commonRESTCallService.getFromServer(url)
            .success(function (data, status) {
                deferred.resolve(data);
            })
            .error(function (data, status) {
                deferred.reject(status + ' ' + JSON.stringify(data));
            });
        return deferred.promise;
    };
    //retrieve product default coverages
    dealerPreferencesService.getProviderDefaultTerms = function(productCode, dateOfSale){
        var deferred = $q.defer();
        if (!(dateOfSale instanceof Date)){
            dateOfSale = new Date(dateOfSale);
        }
        var formattedDate = dateOfSale.yyyymmdd();
        //
        var url =  appSettings.startSPANDealerPreferencesURL + "/DefaultTerms/" + imSessionVarsService.getCurrentProviderCode() + "/" + erateSessionVarsService.getCurrentDealerAccountCode() +
            "/" + checkForUnfriendlyProductCode(productCode) + "/" + formattedDate;
        commonRESTCallService.getFromServer(url)
            .success(function (data, status) {
                deferred.resolve(data);
            })
            .error(function (data, status) {
                deferred.reject(status + ' ' + JSON.stringify(data));
            });
        return deferred.promise;
    };

    //retrieve product default deductibles
    dealerPreferencesService.getProviderDefaultSurcharges = function(productCode, dateOfSale){
        var deferred = $q.defer();

        if (!(dateOfSale instanceof Date)){
            dateOfSale = new Date(dateOfSale);
        }
        var formattedDate = dateOfSale.yyyymmdd();

        var url =  appSettings.startSPANDealerPreferencesURL + "/DefaultSurcharges/" + imSessionVarsService.getCurrentProviderCode() + "/" + erateSessionVarsService.getCurrentDealerAccountCode() +
            "/" + checkForUnfriendlyProductCode(productCode) + "/" + formattedDate;
        commonRESTCallService.getFromServer(url)
            .success(function (data, status) {
                deferred.resolve(data);
            })
            .error(function (data, status) {
                deferred.reject(status + ' ' + JSON.stringify(data));
            });
        return deferred.promise;
    };

    //save display preference for a product
    dealerPreferencesService.saveProductDisplayPreferences = function(productCode, dateOfSale, setting){
        var deferred = $q.defer();

        if (!(dateOfSale instanceof Date)){
            dateOfSale = new Date(dateOfSale);
        }
        var formattedDate = dateOfSale.yyyymmdd();

        //quoteIds assumed to be an array of integers
        var url =  appSettings.startSPANDealerPreferencesURL + "/SaveDisplayPreferences/" + imSessionVarsService.getCurrentProviderCode() + "/" + erateSessionVarsService.getCurrentDealerAccountCode() +
            "/" + formattedDate + "/" + checkForUnfriendlyProductCode(productCode);


        var bsSetting = setting.convertForBusinessServices();
        commonRESTCallService.postToServer(
            url,
            bsSetting
        )
        .success(function (data, status) {
            settingsCacheService.setCachedPreferences(productCode, dateOfSale, setting);
            deferred.resolve(setting);
        })
        .error(function (data, status) {
            deferred.reject(status + ' ' + JSON.stringify(data));
        });

        return deferred.promise;
    };

    return dealerPreferencesService;
}]);
